import { Controller } from "@hotwired/stimulus"

// O token do reCAPTCHA v3 expira em 2 minutos, mas os formularios de
// credenciamento levam mais tempo que isso para preencher. Reexecuta a funcao
// global gerada pela gem (`executeRecaptchaFor<Acao>`) a cada 90s, que grava um
// token novo no input hidden, enquanto o form estiver na tela.
export default class extends Controller {
  static values = { function: String }

  connect() {
    this.timer = setInterval(() => {
      const execute = window[this.functionValue]
      if (typeof execute === "function") execute()
    }, 90000)
  }

  disconnect() {
    clearInterval(this.timer)
  }
}
